<template>
  <div>
    <Row class="web-tools">
      <Col span="12"><iframe frameborder="0" scrolling="no" hspace="0" height="25" src="https://i.tianqi.com/?c=code&a=getcode&id=34&h=25&w=280"></iframe></Col>
      <Col span="12" style="text-align: right; height: 31px; line-height: 31px;">{{webDate}}</Col>
    </Row>
    <div class="web-menu-bg">
      <Row class="web-tools">
        <Col span="12"><router-link to="/"><img :src="logo" class="web-logo"></router-link></Col>
        <Col span="12" class="web-search-wrap">
          <Input v-model="key" placeholder="搜索..." size="large" search class="web-search-opt" @on-search="search">
            <Icon type="ios-search" slot="suffix" />
          </Input>
        </Col>
      </Row>
    </div>
  </div>
  
</template>
<script>
//import nopic from '@/assets/images/nopic.jpg'
import logo from '@/assets/images/logo.jpg'
export default {
  data() {
    return{
      logo: logo,
      webDate: '2020-07-10 10:00:00',
      key: ''
    }
  },

  //页面加载完成
  mounted :function() {
    this.initCurrentTime()
  },

  //页面方法
  methods: {
    //获取当前日期
    initCurrentTime : function() {
      this.webDate = this.getCurrentTime()
      setTimeout(this.initCurrentTime, 500)
    },

    //更新当前时间
    updateCurrentTime : function() {
    },

    //获取当前时间字符串
    getCurrentTime: function() {
      let myDate = new Date();
      let year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      month = month<10 ? '0'+month : month
      let day = myDate.getDate()
      day = day<10 ? '0'+day : day
      let hour = myDate.getHours()
      hour = hour<10 ? '0'+hour : hour
      let minute = myDate.getMinutes()
      minute = minute<10 ? '0'+minute : minute
      let second = myDate.getSeconds()
      second = second<10 ? '0'+second : second
      let timeTxt = year + "-" + month + "-" + day +" " + hour + ":" + minute + ":" + second
      return timeTxt
    },

    //内容搜索
    search() {
      let searchKey = this.key
      if(searchKey=="") {
        this.$Message.error('请您输入搜索关键词');
      } else {
        window.location.href = this.$router.resolve({ path: '/search/news', query: { key: this.key }}).href
      }
    }

  }
}
</script>